import { render, staticRenderFns } from "./EventBrowser.vue?vue&type=template&id=6297c231&scoped=true&"
import script from "./EventBrowser.vue?vue&type=script&lang=js&"
export * from "./EventBrowser.vue?vue&type=script&lang=js&"
import style0 from "./EventBrowser.vue?vue&type=style&index=0&id=6297c231&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297c231",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/event/EventBrowser.vue"
export default component.exports